import React, { useState, useRef, useEffect } from 'react';
import Waveform from '../ui/Waveform';
import Tooltip from '../ui/Tooltip';

const PlayIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M4 12.4696V3.53036C4 3.28565 4.09218 3.08052 4.27654 2.91498C4.46091 2.74944 4.67599 2.66666 4.92181 2.66666C4.99863 2.66666 5.07929 2.67746 5.16379 2.69905C5.24829 2.72065 5.32894 2.75303 5.40576 2.79622L12.9185 7.26585C13.0568 7.35222 13.1605 7.46019 13.2296 7.58974C13.2988 7.7193 13.3333 7.85605 13.3333 8C13.3333 8.14395 13.2988 8.2807 13.2296 8.41025C13.1605 8.53981 13.0568 8.64777 12.9185 8.73414L5.40576 13.2038C5.32894 13.247 5.24829 13.2793 5.16379 13.3009C5.07929 13.3225 4.99863 13.3333 4.92181 13.3333C4.67599 13.3333 4.46091 13.2506 4.27654 13.085C4.09218 12.9195 4 12.7143 4 12.4696Z"
      fill="#FAF7F5"
    />
  </svg>
);

const PauseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 5.33333C4 4.59695 4.59695 4 5.33333 4C6.06971 4 6.66667 4.59695 6.66667 5.33333V10.6667C6.66667 11.403 6.06971 12 5.33333 12C4.59695 12 4 11.403 4 10.6667V5.33333Z" fill="#FAF7F5"/>
    <path d="M9.33333 5.33333C9.33333 4.59695 9.93029 4 10.6667 4C11.403 4 12 4.59695 12 5.33333V10.6667C12 11.403 11.403 12 10.6667 12C9.93029 12 9.33333 11.403 9.33333 10.6667V5.33333Z" fill="#FAF7F5"/>
  </svg>
);

const EditIcon = () => (
  <svg
    width={17}
    height={17}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-[16.79px] h-[16.79px] relative"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M2.90495 14.776C2.51869 14.776 2.20557 14.4629 2.20557 14.0766V12.0937C2.20557 11.908 2.27943 11.7299 2.41088 11.5987L11.4375 2.58922C11.5773 2.461 11.7318 2.36192 11.9008 2.29198C12.0698 2.22204 12.2476 2.18707 12.4341 2.18707C12.6206 2.18707 12.8013 2.22204 12.9761 2.29198C13.151 2.36192 13.3025 2.46683 13.4307 2.6067L14.3924 3.58585C14.5323 3.71407 14.6342 3.8656 14.6984 4.04045C14.7625 4.21529 14.7945 4.39014 14.7945 4.56499C14.7945 4.75149 14.7625 4.92925 14.6984 5.09827C14.6342 5.26729 14.5323 5.42174 14.3924 5.56161L5.3828 14.5712C5.25164 14.7023 5.07375 14.776 4.88826 14.776H2.90495ZM12.4166 5.54413L13.3957 4.56499L12.4166 3.58585L11.4375 4.56499L12.4166 5.54413Z"
      fill="#FAF7F5"
    />
  </svg>
);

const CloseIcon = () => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-[16.79px] h-[16.79px] relative"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M9.01839 9.96073L5.59139 13.3877C5.46317 13.5159 5.29998 13.5801 5.10182 13.5801C4.90366 13.5801 4.74047 13.5159 4.61225 13.3877C4.48403 13.2595 4.41992 13.0963 4.41992 12.8981C4.41992 12.7 4.48403 12.5368 4.61225 12.4086L8.03925 8.98158L4.61225 5.55459C4.48403 5.42637 4.41992 5.26318 4.41992 5.06502C4.41992 4.86686 4.48403 4.70367 4.61225 4.57545C4.74047 4.44723 4.90366 4.38312 5.10182 4.38312C5.29998 4.38312 5.46317 4.44723 5.59139 4.57545L9.01839 8.00244L12.4454 4.57545C12.5736 4.44723 12.7368 4.38312 12.935 4.38312C13.1331 4.38312 13.2963 4.44723 13.4245 4.57545C13.5527 4.70367 13.6169 4.86686 13.6169 5.06502C13.6169 5.26318 13.5527 5.42637 13.4245 5.55459L9.99753 8.98158L13.4245 12.4086C13.5527 12.5368 13.6169 12.7 13.6169 12.8981C13.6169 13.0963 13.5527 13.2595 13.4245 13.3877C13.2963 13.5159 13.1331 13.5801 12.935 13.5801C12.7368 13.5801 12.5736 13.5159 12.4454 13.3877L9.01839 9.96073Z"
      fill="#FAF7F5"
    />
  </svg>
);

const TrimAudioModal = ({
  fileName = "Untitled",
  onContinue,
  onClose,
  audioFile = null,
  className = ""
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(120); // 2 minutes default
  const [progress, setProgress] = useState(0.1); // Start at beginning of trim selection
  const [trimStart, setTrimStart] = useState(0.1);
  const [trimEnd, setTrimEnd] = useState(0.8);
  const [audioSrc, setAudioSrc] = useState("audio.mp3");
  const [isDraggingTrim, setIsDraggingTrim] = useState(null);
  const audioRef = useRef(null);

  // Handle uploaded audio file
  useEffect(() => {
    if (audioFile) {
      // Add a small delay to ensure the file is ready
      const timeoutId = setTimeout(() => {
        const url = URL.createObjectURL(audioFile);
        setAudioSrc(url);
      }, 100);
      
      return () => {
        clearTimeout(timeoutId);
        // Clean up will be handled by the parent component
      };
    }
  }, [audioFile]);

  // Audio event handlers
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const handleLoadedMetadata = () => {
      setDuration(audio.duration);
      // Set progress to start of trim selection when audio loads
      setProgress(trimStart);
    };

    const handleTimeUpdate = () => {
      setCurrentTime(audio.currentTime);
      const audioProgress = audio.currentTime / audio.duration;
      setProgress(audioProgress);
    };

    const handleEnded = () => {
      setIsPlaying(false);
      setCurrentTime(0);
      setProgress(trimStart);
    };

    audio.addEventListener('loadedmetadata', handleLoadedMetadata);
    audio.addEventListener('timeupdate', handleTimeUpdate);
    audio.addEventListener('ended', handleEnded);

    return () => {
      audio.removeEventListener('loadedmetadata', handleLoadedMetadata);
      audio.removeEventListener('timeupdate', handleTimeUpdate);
      audio.removeEventListener('ended', handleEnded);
    };
  }, [audioSrc]);

  // Format time helper
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  // Play/pause handler
  const handlePlayPause = async () => {
    const audio = audioRef.current;
    if (!audio) return;

    try {
      if (isPlaying) {
        audio.pause();
        setIsPlaying(false);
      } else {
        // Set audio to start of trim selection if at beginning
        if (progress <= trimStart) {
          audio.currentTime = trimStart * duration;
        }
        await audio.play();
        setIsPlaying(true);
      }
    } catch (error) {
      console.error('Error playing audio:', error);
    }
  };

  const handleProgressChange = (newProgress) => {
    const audio = audioRef.current;
    if (audio && duration) {
      const newTime = newProgress * duration;
      audio.currentTime = newTime;
      setCurrentTime(newTime);
      setProgress(newProgress);
    }
  };

  const handleTrimChange = (start, end) => {
    const newTrimStart = Math.max(0, Math.min(start, end - 0.01));
    const newTrimEnd = Math.max(start + 0.01, Math.min(1, end));
    
    setTrimStart(newTrimStart);
    setTrimEnd(newTrimEnd);
    
    // Move progress to the new trim start position
    setProgress(newTrimStart);
    
    // Update audio currentTime to match the new position
    const audio = audioRef.current;
    if (audio && duration) {
      audio.currentTime = newTrimStart * duration;
    }
  };

  // Handle trim drag state changes
  const handleTrimDragChange = (dragState) => {
    setIsDraggingTrim(dragState);
  };

  const getTrimStartTime = () => {
    return trimStart * duration;
  };

  const getTrimEndTime = () => {
    return trimEnd * duration;
  };

  const handleContinue = () => {
    const trimData = {
      fileName,
      audioUrl: audioSrc,
      audioFile,
      trimStart,
      trimEnd,
      trimStartTime: getTrimStartTime(),
      trimEndTime: getTrimEndTime(),
      duration
    };
    onContinue?.(trimData);
  };

  return (
    <div className={`flex flex-col justify-between items-start w-[450px] h-[560px] overflow-hidden rounded-3xl bg-[#252020] ${className}`}>
      {/* Header */}
      <div className="flex justify-between items-center self-stretch flex-grow-0 flex-shrink-0 p-6">
        {/* Invisible spacer */}
        <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 w-[42px] h-[42px] opacity-0" />
        
        {/* Title and duration */}
        <div className="flex flex-col justify-center items-center flex-grow-0 flex-shrink-0 relative gap-1">
          <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 relative gap-1 pl-4">
            <p className="flex-grow-0 flex-shrink-0 text-lg font-medium text-left text-[#726e6c] truncate" style={{ maxWidth: '150px' }}>
              {fileName}
            </p>
            <EditIcon />
          </div>
          <p className="flex-grow-0 flex-shrink-0 text-[11px] text-left text-[#bab4b1]">
            {formatTime(currentTime)} / {formatTime(getTrimEndTime())}
          </p>
        </div>
        
        {/* Close button */}
        <button 
          className="flex justify-center items-center flex-grow-0 flex-shrink-0 w-[42px] h-[42px] relative rounded-full bg-[#363030] hover:bg-[#403636] transition-colors"
          onClick={onClose}
        >
          <CloseIcon />
        </button>
      </div>

      {/* Waveform section */}
      <div className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 relative gap-4 px-6">
        {/* Play button */}
        <button 
          className="flex justify-center items-center flex-grow-0 flex-shrink-0 w-20 h-20 relative rounded-xl bg-[#363030] hover:bg-[#403636] transition-colors"
          onClick={handlePlayPause}
        >
          {isPlaying ? <PauseIcon /> : <PlayIcon />}
        </button>
        
        {/* Waveform */}
        <div className="flex-grow h-20 relative">
          <Waveform
            audioSrc={audioSrc}
            audioFile={audioFile}
            progress={progress}
            onProgressChange={handleProgressChange}
            isPlaying={isPlaying}
            showTrimHandles={true}
            trimStart={trimStart}
            trimEnd={trimEnd}
            onTrimChange={handleTrimChange}
            onTrimDragChange={handleTrimDragChange}
            className="w-full"
          />
          
          {/* Trim Start Tooltip */}
          {isDraggingTrim === 'start' && (
            <div 
              className="absolute pointer-events-none"
              style={{
                left: `calc(0.75rem + ${trimStart} * (100% - 1.5rem))`,
                top: '-4px',
                zIndex: 40
              }}
            >
              <Tooltip
                text={formatTime(getTrimStartTime())}
                isVisible={true}
                position="top"
                offset={4}
              />
            </div>
          )}
          
          {/* Trim End Tooltip */}
          {isDraggingTrim === 'end' && (
            <div 
              className="absolute pointer-events-none"
              style={{
                left: `calc(0.75rem + ${trimEnd} * (100% - 1.5rem))`,
                top: '-4px',
                zIndex: 40
              }}
            >
              <Tooltip
                text={formatTime(getTrimEndTime())}
                isVisible={true}
                position="top"
                offset={4}
              />
            </div>
          )}
        </div>
      </div>

      {/* Bottom section */}
      <div className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0">
        {/* Continue button */}
        <div className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 pt-6">
          <div className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 gap-[9px] px-6">
            <button 
              className="flex justify-center items-center flex-grow h-14 relative gap-1 px-[150px] py-[19px] rounded-full bg-[#faf7f5] hover:bg-[#e5e2e0] transition-colors"
              onClick={handleContinue}
            >
              <p className="flex-grow-0 flex-shrink-0 text-lg font-semibold text-left text-[#0e0808]">
                Continue
              </p>
            </button>
          </div>
        </div>
        
        {/* Footer text */}
        <div className="flex justify-center items-center self-stretch flex-grow-0 flex-shrink-0 h-[60px] relative p-6">
          <p className="flex-grow-0 flex-shrink-0 text-xs text-left text-[#726e6c]">
            1 min limit. Upgrade to use longer audio (8 min)
          </p>
        </div>
      </div>

      {/* Hidden audio element */}
      <audio ref={audioRef} src={audioSrc} preload="metadata" />
    </div>
  );
};

export default TrimAudioModal;